import { GAME_ID, REDUX_ACTIONS, GAME_MODES, MASTERY_CRITERIA } from '../../data/constants';

export const initState = {
  levelIndex: 0,
  mode: GAME_MODES.READING,
  test: 0, // round 1 is first autoscrolling read-through, round 2 is second
  questionIndex: 0,
  progress: 0, // for progress bar, increment every time a question is answered
  question: {},
  secondsElapsed: null,
};

const roundPlayReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_LEVEL_INDEX:
      return {
        ...initState, // reset state to initial values for a round
        levelIndex: payload,
      };

    case REDUX_ACTIONS.SET_QUESTION:
      return {
        ...state,
        question: payload.question,
      };

    case REDUX_ACTIONS.CHANGE_GAME_MODE:
      return {
        ...state,
        ...payload,
      };

    case REDUX_ACTIONS.INCREMENT_TEST:
      return {
        ...state,
        test: state.test + 1,
      };

    case REDUX_ACTIONS.INCREMENT_QUESTION_INDEX:
      return {
        ...state,
        questionIndex: state.questionIndex + 1,
      };

    case REDUX_ACTIONS.RESET_QUESTION_INDEX:
      return {
        ...state,
        questionIndex: 0,
      };

    case REDUX_ACTIONS.START_NEXT_TEST:
      return {
        ...state,
        mode: GAME_MODES.READING,
        test: state.test + 1,
        questionIndex: 0,
      };

    case REDUX_ACTIONS.INCREMENT_PROGRESS:
      return {
        ...state,
        progress: state.progress + 1,
      };

    case REDUX_ACTIONS.SET_SECONDS_ELAPSED:
      return {
        ...state,
        secondsElapsed: payload.secondsElapsed,
      };

    case REDUX_ACTIONS.QUICK_PASS:
      return {
        ...state,
        progress: MASTERY_CRITERIA.QUESTIONS,
        questionIndex: MASTERY_CRITERIA.QUESTIONS,
      };

    case REDUX_ACTIONS.QUICK_FAIL:
      return {
        ...state,
        questionIndex: MASTERY_CRITERIA.QUESTIONS,
      };

    default:
      return state;
  }
};

export default roundPlayReducer;
